import React from 'react';
import styles from './StepProgress.module.scss';

interface StepProgressProps {
  currentStep: number;
  totalSteps: number;
  hideLabel?: boolean;
  /** When true, only the current step dot is highlighted — past steps render as gray instead of complete. */
  highlightCurrentOnly?: boolean;
}

export default function StepProgress({ currentStep, totalSteps, hideLabel, highlightCurrentOnly }: StepProgressProps) {
  return (
    <div className={styles.progress}>
      <div className={styles.dots}>
        {Array.from({ length: totalSteps }, (_, i) => {
          const step = i + 1;
          let stateClass = '';
          if (step < currentStep && !highlightCurrentOnly) {
            stateClass = styles.complete;
          } else if (step === currentStep) {
            stateClass = styles.active;
          }
          return <div key={step} className={`${styles.dot} ${stateClass}`} />;
        })}
      </div>
      {!hideLabel && (
        <div className={styles.label}>
          Step {currentStep} of {totalSteps}
        </div>
      )}
    </div>
  );
}
